import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-dialog-delete-confirmation',
  templateUrl: './dialog-delete-confirmation.component.html',
  styleUrls: ['./dialog-delete-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogModule,
  ],
})
export class DialogDeleteConfirmationComponent {
  public confirmMessage!: string;

  constructor(
    public dialogRef: MatDialogRef<DialogDeleteConfirmationComponent>
  ) {}

  close() {
    this.dialogRef.close(false);
  }

  save() {
    this.dialogRef.close(true);
  }
}
